/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingDataViewModel } from '../../models/marketing-data-view-model';

export interface GetMarketingDataByMerchant$Params {
  merchantId: string;
  marketingDataId: string;
}

export function getMarketingDataByMerchant(http: HttpClient, rootUrl: string, params: GetMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingDataViewModel>> {
  const rb = new RequestBuilder(rootUrl, getMarketingDataByMerchant.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('marketingDataId', params.marketingDataId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketingDataViewModel>;
    })
  );
}

getMarketingDataByMerchant.PATH = '/merchants/{merchantId}/marketing-data/{marketingDataId}';
